import { render } from "./ChatUndocked.vue?vue&type=template&id=33f1bdac"
import script from "./ChatUndocked.vue?vue&type=script&lang=js"
export * from "./ChatUndocked.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/ChatUndocked.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33f1bdac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33f1bdac', __exports__)) {
    api.reload('33f1bdac', __exports__)
  }
  
  module.hot.accept("./ChatUndocked.vue?vue&type=template&id=33f1bdac", () => {
    api.rerender('33f1bdac', render)
  })

}


export default __exports__